import { apiCall } from './gqlClient';
const GETCLASSES_QUERY = "\n  query getClasses($serviceId: Int!) {\n    getClasses(serviceId: $serviceId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tminimumCapacity\n\t\t\tprice\n\t\t\tmodel\n\t\t\tsessionLimit\n\t\t\tactive\n\t\t\torderIndex\n\t\t\tsessionsCounter\n\t\t\tentityType\n\t\t\tlocationType\n\t\t\tcustomerId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getClassesApiCall = async function (_ref) {
  let {
    serviceId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCLASSES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETPUBLICCLASSES_QUERY = "\n  query getPublicClasses($serviceId: Int!) {\n    getPublicClasses(serviceId: $serviceId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tminimumCapacity\n\t\t\tprice\n\t\t\tmodel\n\t\t\tsessionLimit\n\t\t\tactive\n\t\t\torderIndex\n\t\t\tsessionsCounter\n\t\t\tentityType\n\t\t\tlocationType\n\t\t\tcustomerId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getPublicClassesApiCall = async function (_ref2) {
  let {
    serviceId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPUBLICCLASSES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETPROVIDERCLASSES_QUERY = "\n  query getProviderClasses($serviceId: Int!) {\n    getProviderClasses(serviceId: $serviceId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tminimumCapacity\n\t\t\tprice\n\t\t\tmodel\n\t\t\tsessionLimit\n\t\t\tactive\n\t\t\torderIndex\n\t\t\tsessionsCounter\n\t\t\tentityType\n\t\t\tlocationType\n\t\t\tcustomerId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getProviderClassesApiCall = async function (_ref3) {
  let {
    serviceId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPROVIDERCLASSES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETCLASSESFORBOOKING_QUERY = "\n  query getClassesForBooking($providerId: Int) {\n    getClassesForBooking(providerId: $providerId)\n    {\n      id\n\t\t\tname\n\t\t\tserviceType\n\t\t\tisAlwaysAvailable\n      ...fragments\n    }\n  }";
export const getClassesForBookingApiCall = async function (_ref4) {
  let {
    providerId
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCLASSESFORBOOKING_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};
const GETPROVIDERALLCLASSES_QUERY = "\n  query getProviderAllClasses($serviceId: Int!) {\n    getProviderAllClasses(serviceId: $serviceId)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tminimumCapacity\n\t\t\tprice\n\t\t\tmodel\n\t\t\tsessionLimit\n\t\t\tactive\n\t\t\torderIndex\n\t\t\tsessionsCounter\n\t\t\tentityType\n\t\t\tlocationType\n\t\t\tcustomerId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getProviderAllClassesApiCall = async function (_ref5) {
  let {
    serviceId
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPROVIDERALLCLASSES_QUERY,
    variables: {
      serviceId
    },
    fragments
  });
};
const GETBUSINESSCLASSDETAILS_QUERY = "\n  query getBusinessClassDetails($id: Int!) {\n    getBusinessClassDetails(id: $id)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tminimumCapacity\n\t\t\tprice\n\t\t\tmodel\n\t\t\tsessionLimit\n\t\t\tactive\n\t\t\torderIndex\n\t\t\tsessionsCounter\n\t\t\tentityType\n\t\t\tlocationType\n\t\t\tcustomerId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getBusinessClassDetailsApiCall = async function (_ref6) {
  let {
    id
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETBUSINESSCLASSDETAILS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETCLASSDETAILS_QUERY = "\n  query getClassDetails($id: Int!) {\n    getClassDetails(id: $id)\n    {\n      id\n\t\t\tproviderId\n\t\t\tserviceId\n\t\t\tname\n\t\t\tdescription\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tduration\n\t\t\tcapacity\n\t\t\tminimumCapacity\n\t\t\tprice\n\t\t\tmodel\n\t\t\tsessionLimit\n\t\t\tactive\n\t\t\torderIndex\n\t\t\tsessionsCounter\n\t\t\tentityType\n\t\t\tlocationType\n\t\t\tcustomerId\n\t\t\tpreparationTime\n\t\t\tcredits\n      ...fragments\n    }\n  }";
export const getClassDetailsApiCall = async function (_ref7) {
  let {
    id
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCLASSDETAILS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const DELETECLASS_QUERY = "\n  mutation deleteClass($id: Int!) {\n    deleteClass(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const deleteClassApiCall = async function (_ref8) {
  let {
    id
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETECLASS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const RESTORECLASS_QUERY = "\n  mutation restoreClass($id: Int!) {\n    restoreClass(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const restoreClassApiCall = async function (_ref9) {
  let {
    id
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTORECLASS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const DELETEINACTIVESESSIONS_QUERY = "\n  mutation deleteInactiveSessions($classId: Int!) {\n    deleteInactiveSessions(classId: $classId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const deleteInactiveSessionsApiCall = async function (_ref10) {
  let {
    classId
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEINACTIVESESSIONS_QUERY,
    variables: {
      classId
    },
    fragments
  });
};
const SAVECLASS_QUERY = "\n  mutation saveClass($request: GyClassCreateInput!) {\n    saveClass(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveClassApiCall = async function (_ref11) {
  let {
    request
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVECLASS_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const SAVECOURSEWITHCLASS_QUERY = "\n  mutation saveCourseWithClass($request: ServicePlusSubServiceCreateInput!) {\n    saveCourseWithClass(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveCourseWithClassApiCall = async function (_ref12) {
  let {
    request
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVECOURSEWITHCLASS_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const TOGGLECLASSSTATUS_QUERY = "\n  mutation toggleClassStatus($id: Int!, $isActive: Boolean!, $serviceId: Int!) {\n    toggleClassStatus(id: $id, isActive: $isActive, serviceId: $serviceId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const toggleClassStatusApiCall = async function (_ref13) {
  let {
    id,
    isActive,
    serviceId
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLECLASSSTATUS_QUERY,
    variables: {
      id,
      isActive,
      serviceId
    },
    fragments
  });
};
const REORDERCLASSES_QUERY = "\n  mutation reorderClasses($serviceId: Int!, $oldPosition: Int!, $newPosition: Int!) {\n    reorderClasses(serviceId: $serviceId, oldPosition: $oldPosition, newPosition: $newPosition)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const reorderClassesApiCall = async function (_ref14) {
  let {
    serviceId,
    oldPosition,
    newPosition
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERCLASSES_QUERY,
    variables: {
      serviceId,
      oldPosition,
      newPosition
    },
    fragments
  });
};